<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="prod_id" [ttModel]="edit.prod_id" ttReadonly></tt-input>

        <div *ngIf="edit.isnew === '0'">
            <tt-input ttLabel="unit_name_shortname" [ttModel]="edit.unit_name_shortname" ttReadonly></tt-input>
            <tt-button ttText="delete" (ttClick)="deleteValues()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting"></tt-button>
        </div>

        <div *ngIf="edit.isnew === '1'">
            <tt-select ttLabel="unit" [(ttModel)]="edit.unit_no" [ttData]="selectListNewProductUnits" ttDataId="unit_no" ttDataName="unit_name"></tt-select>
            <tt-button-save ttText="save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
        </div>
    </tt-card>
</tt-page>
